module.exports = __webpack_public_path__ + "img/Sunny Aggarwal.2e4b9140.jpg";